export default "/images/dollar-sign.svg?8d9a6f938731fde21207ac6851ae5fcb";